import { httpRequest } from "../../http";

export type SetupStatusItem = {
  key: string;
  // "attention" = set up enough to proceed, but data is still missing (rendered orange).
  // It is not "incomplete", so it never blocks publish readiness.
  status: "complete" | "incomplete" | "not_applicable" | "attention";
  summary: string;
};

export type SetupStatusResponse = {
  engagement_id: number;
  items: SetupStatusItem[];
};

export class CommandGetEngagementSetupStatus {
  async run(engagementId: number): Promise<SetupStatusResponse> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/setup-status/`;
    return await httpRequest<SetupStatusResponse>(url, { method: "GET" });
  }
}
